var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("所有标签：")]),_vm._v(" "),_vm._l((_vm.labels),function(label){return (_vm.labels.length)?_c('Tag',{key:label.id,attrs:{"color":label.color,"src":'/tags/' + label.name}},[_vm._v("\n    "+_vm._s(label.name)+"\n  ")]):_c('div',{staticClass:"loader"})}),_vm._v(" "),_c('router-view')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e15769f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tags/tags.vue
// module id = null
// module chunks = 